<template>
    <Button @click="$router.go(-1)" class="voltar-btn border-none" text rounded>
        <div class="flex flex-row align-items-center justify-content-center">
            <i class="pi pi-arrow-left mr-2"></i>
            <p>Voltar</p>
        </div>
    </Button>
</template>
<script>
export default {};
</script>
<style>
.voltar-btn {
    width: max-content !important;
    background-color: #ffffff00 !important;
    color: #3e6ba8 !important;
    font-weight: bold;
    font-size: 1rem;
    margin: 0;
    margin-bottom: 10px;
    padding: 0;
}
</style>
